import React from "react";
import { useNavigate } from "react-router-dom";
import { AuroraBackground } from "@/components/AuroraBackground";
import { BrandMark } from "@/components/BrandMark";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { useI18n } from "@/i18n";
import { ArrowLeft } from "lucide-react";

export const Login = () => {
  const navigate = useNavigate();
  const { t } = useI18n();

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="relative min-h-screen text-white grid md:grid-cols-2">
      <AuroraBackground />
      {/* Left visual */}
      <div className="relative z-10 hidden md:flex flex-col justify-between p-12 border-r border-white/5">
        <button onClick={() => navigate("/")} className="flex items-center gap-2 text-zinc-400 hover:text-white transition-colors w-fit">
          <ArrowLeft className="w-4 h-4" /> <span className="font-mono text-xs uppercase tracking-widest">{t("login.back")}</span>
        </button>
        <div>
          <div className="font-mono text-xs text-aurora-cyan tracking-[0.3em] uppercase mb-4">{t("login.kicker")}</div>
          <h1 className="font-display text-5xl font-bold uppercase leading-[0.95] tracking-tight">
            {t("login.titleLine1")}<br />{t("login.titleLine2")}<br /><span className="text-aurora-cyan text-glow-cyan">{t("login.titleLine3")}</span>
          </h1>
          <p className="mt-6 text-zinc-400 max-w-sm">
            {t("login.subtitle")}
          </p>
        </div>
        <div className="font-mono text-[10px] text-zinc-600 tracking-widest uppercase">ECU · OBD-II · KESS · KTAG</div>
      </div>

      {/* Right form */}
      <div className="relative z-10 flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="flex items-center justify-between mb-10">
            <BrandMark size="lg" subtitle="Automotive Files Portal" />
            <LanguageSwitcher />
          </div>

          <h2 className="font-display text-3xl font-semibold uppercase tracking-tight mb-2">{t("login.connection")}</h2>
          <p className="text-zinc-400 text-sm mb-8">{t("login.access")}</p>

          <button
            onClick={handleGoogle}
            data-testid="google-login-btn"
            className="w-full flex items-center justify-center gap-3 px-5 py-3.5 bg-white text-black font-display font-bold uppercase tracking-wider rounded-sm hover:bg-zinc-200 transition-colors"
          >
            <svg className="w-5 h-5" viewBox="0 0 48 48">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
            </svg>
            {t("login.google")}
          </button>

          <p className="mt-6 text-center font-mono text-[10px] text-zinc-600 tracking-wider">
            {t("login.secure")}
          </p>
        </div>
      </div>
    </div>
  );
};
